import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withKeys as _withKeys } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "card mb-5 mb-xl-10" }
const _hoisted_4 = { class: "card-header border-0" }
const _hoisted_5 = { class: "card-title m-0" }
const _hoisted_6 = { class: "fw-bolder m-0" }
const _hoisted_7 = { class: "card-title m-0" }
const _hoisted_8 = { class: "collapse show" }
const _hoisted_9 = { class: "card-body border-top p-9" }
const _hoisted_10 = { class: "row mb-6" }
const _hoisted_11 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_12 = { class: "col-lg-8 fv-row" }
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "row mb-6" }
const _hoisted_16 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_17 = { class: "col-lg-8 fv-row" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_23 = { class: "fv-plugins-message-container" }
const _hoisted_24 = { class: "fv-help-block" }
const _hoisted_25 = { class: "row mb-6" }
const _hoisted_26 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_27 = { class: "col-lg-8 fv-row" }
const _hoisted_28 = { class: "fv-plugins-message-container" }
const _hoisted_29 = { class: "fv-help-block" }
const _hoisted_30 = { class: "row mb-6" }
const _hoisted_31 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_32 = { class: "col-lg-8 fv-row" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope fs-3" }, null, -1)
const _hoisted_34 = { class: "fv-plugins-message-container" }
const _hoisted_35 = { class: "fv-help-block" }
const _hoisted_36 = { class: "row mb-6" }
const _hoisted_37 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_38 = { class: "col-lg-8 fv-row" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone fs-3" }, null, -1)
const _hoisted_40 = { class: "fv-plugins-message-container" }
const _hoisted_41 = { class: "fv-help-block" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-5" }, null, -1)
const _hoisted_43 = { class: "pb-5" }
const _hoisted_44 = { class: "fw-bolder d-flex align-items-center text-dark groupLabel" }
const _hoisted_45 = { class: "row mb-6" }
const _hoisted_46 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_47 = { class: "col-lg-8 fv-row" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marker-alt fs-3" }, null, -1)
const _hoisted_49 = { class: "fv-plugins-message-container" }
const _hoisted_50 = { class: "fv-help-block" }
const _hoisted_51 = { class: "row mb-6" }
const _hoisted_52 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_53 = { class: "col-lg-8 fv-row" }
const _hoisted_54 = { class: "fv-plugins-message-container" }
const _hoisted_55 = { class: "fv-help-block" }
const _hoisted_56 = { class: "row mb-6" }
const _hoisted_57 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_58 = { class: "col-lg-8 fv-row" }
const _hoisted_59 = { class: "fv-plugins-message-container" }
const _hoisted_60 = { class: "fv-help-block" }
const _hoisted_61 = { class: "row mb-6" }
const _hoisted_62 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_63 = { class: "col-lg-8 fv-row" }
const _hoisted_64 = { class: "fv-plugins-message-container" }
const _hoisted_65 = { class: "fv-help-block" }
const _hoisted_66 = { class: "card mb-5 mb-xl-10" }
const _hoisted_67 = { class: "card-header border-0" }
const _hoisted_68 = { class: "card-title m-0" }
const _hoisted_69 = { class: "fw-bolder m-0" }
const _hoisted_70 = { class: "collapse show" }
const _hoisted_71 = { class: "card-body border-top p-9" }
const _hoisted_72 = { class: "row mb-6" }
const _hoisted_73 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_74 = { class: "col-lg-8 fv-row" }
const _hoisted_75 = { class: "fv-plugins-message-container" }
const _hoisted_76 = { class: "fv-help-block" }
const _hoisted_77 = { class: "row mb-6" }
const _hoisted_78 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_79 = { class: "col-lg-8 fv-row" }
const _hoisted_80 = { class: "fv-plugins-message-container" }
const _hoisted_81 = { class: "fv-help-block" }
const _hoisted_82 = { class: "row mb-6" }
const _hoisted_83 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_84 = { class: "col-lg-8 fv-row" }
const _hoisted_85 = { class: "fv-plugins-message-container" }
const _hoisted_86 = { class: "fv-help-block" }
const _hoisted_87 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_88 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_89 = { class: "col-lg-8 fv-row" }
const _hoisted_90 = { class: "fv-plugins-message-container" }
const _hoisted_91 = { class: "fv-help-block" }
const _hoisted_92 = { class: "row mb-6" }
const _hoisted_93 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_94 = { class: "col-lg-8 fv-row" }
const _hoisted_95 = { class: "fv-plugins-message-container" }
const _hoisted_96 = { class: "fv-help-block" }
const _hoisted_97 = { class: "row mb-6" }
const _hoisted_98 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_99 = { class: "col-lg-8 fv-row" }
const _hoisted_100 = { class: "el-upload-list el-upload-list--text" }
const _hoisted_101 = { class: "col-lg-10 fv-row fv-plugins-icon-container d-inline-block align-middle" }
const _hoisted_102 = ["download", "href"]
const _hoisted_103 = /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","justify-content":"center","align-items":"center","width":"100%","height":"100%","background":"#f5f7fa","color":"var(--el-text-color-secondary)","font-size":"10px"} }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "50",
    height: "50",
    fill: "currentColor",
    class: "bi bi-filetype-pdf",
    viewBox: "0 0 16 16"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z"
    })
  ])
], -1)
const _hoisted_104 = { class: "d-inline-block align-middle my-2 ms-1" }
const _hoisted_105 = {
  key: 0,
  class: "align-middle"
}
const _hoisted_106 = ["onClick"]
const _hoisted_107 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
const _hoisted_108 = [
  _hoisted_107
]
const _hoisted_109 = {
  key: 1,
  class: "align-middle"
}
const _hoisted_110 = ["onClick"]
const _hoisted_111 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-trash-alt fs-1" }, null, -1)
const _hoisted_112 = [
  _hoisted_111
]
const _hoisted_113 = { class: "row mb-6" }
const _hoisted_114 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_115 = { class: "col-lg-8 fv-row" }
const _hoisted_116 = {
  class: "dropzone",
  id: "kt_dropzonejs_nuevos_documentosFamilia"
}
const _hoisted_117 = { class: "dz-message needsclick" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-arrow-up text-primary fs-3x" }, null, -1)
const _hoisted_119 = { class: "ms-4" }
const _hoisted_120 = { class: "fs-5 fw-bolder text-gray-900 mb-1" }
const _hoisted_121 = { class: "fs-7 fw-bold text-gray-400" }
const _hoisted_122 = { class: "card mb-5 mb-xl-10" }
const _hoisted_123 = { class: "card-header border-0" }
const _hoisted_124 = { class: "card-title m-0" }
const _hoisted_125 = { class: "fw-bolder m-0" }
const _hoisted_126 = { class: "collapse show" }
const _hoisted_127 = { class: "card-body border-top p-9" }
const _hoisted_128 = {
  key: 0,
  class: "separator separator-dashed my-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_CurrencyInput = _resolveComponent("CurrencyInput")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Menor = _resolveComponent("Menor")!
  const _component_ServiciosTabla = _resolveComponent("ServiciosTabla")!
  const _component_ServiciosColectivosTabla = _resolveComponent("ServiciosColectivosTabla")!
  const _component_Historico = _resolveComponent("Historico")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_Page = _resolveComponent("Page")!
  const _component_CrearMenorModal = _resolveComponent("CrearMenorModal")!
  const _component_MenorServicioProgramadoModal = _resolveComponent("MenorServicioProgramadoModal")!
  const _component_MenorServicioIndividualModal = _resolveComponent("MenorServicioIndividualModal")!
  const _component_SendEmailModal = _resolveComponent("SendEmailModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Page, { showBack: "" }, {
      actions: _withCtx(() => [
        _createVNode(_component_el_dropdown, { class: "mx-3" }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, {
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#mau_modal_add_menor"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("page.acciones.añadirMenor")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, {
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#mau_modal_menor_servicio_programado"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("page.acciones.añadirMenorServicioProgramado")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, {
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#mau_modal_menor_servicio_individual"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("page.acciones.añadirMenorServicioIndividual")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, {
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#mau_modal_send_email",
                  onClick: _ctx.prepareSendEmail
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("page.acciones.enviarCorreo")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_divider, { class: "my-2" }),
                _createVNode(_component_el_dropdown_item, {
                  onClick: _ctx.eliminar,
                  disabled: _ctx.serviciosAprobados.length
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("page.acciones.eliminar")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_button, { type: "default" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("formularios.servicioDetalle.acciones.button")) + " ", 1),
                _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_arrow_down)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.onSubmit,
          loading: _ctx.guardaDetalle,
          disabled: _ctx.isReading
        }, {
          default: _withCtx(() => [
            (!_ctx.isReading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.guardar.button")), 1))
              : (_ctx.isReading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.cargandoArchivos")), 1))
                : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onClick", "loading", "disabled"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_tabs, { type: "border-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('formularios.familiaDetalle.datosSolicitanteGroup')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t("formularios.familiaDetalle.datosSolicitanteGroup")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("span", {
                        class: _normalizeClass(_ctx.claseEstado)
                      }, _toDisplayString(_ctx.estado), 3)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("formularios.familiaDetalle.tratamiento.label")), 1),
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_el_select, {
                            name: "tratamiento",
                            class: "w-100",
                            modelValue: _ctx.tratamiento,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tratamiento) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tratamientos, (tratamiento, i) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: i,
                                  label: tratamiento.text,
                                  value: tratamiento.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(_component_ErrorMessage, { name: "tratamiento" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("formularios.familiaDetalle.nombre.label")), 1),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createVNode(_component_el_input, {
                                type: "text",
                                name: "nombre",
                                placeholder: " ",
                                modelValue: _ctx.nombre,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nombre) = $event))
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("div", _hoisted_21, [
                                  _createVNode(_component_ErrorMessage, { name: "nombre" })
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_22, [
                              _createVNode(_component_el_input, {
                                type: "text",
                                name: "apellidos",
                                placeholder: " ",
                                modelValue: _ctx.apellidos,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.apellidos) = $event))
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("div", _hoisted_24, [
                                  _createVNode(_component_ErrorMessage, { name: "apellidos" })
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("formularios.familiaDetalle.dni.label")), 1),
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_component_el_input, {
                            type: "text",
                            name: "dni",
                            placeholder: " ",
                            modelValue: _ctx.dni,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dni) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createVNode(_component_ErrorMessage, { name: "dni" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t("formularios.familiaDetalle.email.label")), 1),
                        _createElementVNode("div", _hoisted_32, [
                          _createVNode(_component_el_input, {
                            type: "text",
                            name: "email",
                            placeholder: " ",
                            modelValue: _ctx.email,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.email) = $event))
                          }, {
                            append: _withCtx(() => [
                              _hoisted_33
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              _createVNode(_component_ErrorMessage, { name: "email" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t("formularios.familiaDetalle.telefono.label")), 1),
                        _createElementVNode("div", _hoisted_38, [
                          _createVNode(_component_el_input, {
                            type: "text",
                            name: "telefono",
                            placeholder: " ",
                            modelValue: _ctx.telefono,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.telefono) = $event))
                          }, {
                            append: _withCtx(() => [
                              _hoisted_39
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                              _createVNode(_component_ErrorMessage, { name: "telefono" })
                            ])
                          ])
                        ])
                      ]),
                      _hoisted_42,
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("h4", _hoisted_44, _toDisplayString(_ctx.$t("formularios.familiaDetalle.direccionGroup")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.$t("formularios.familiaDetalle.direccion.label")), 1),
                        _createElementVNode("div", _hoisted_47, [
                          _createVNode(_component_el_input, {
                            type: "text",
                            name: "direccion",
                            placeholder: " ",
                            modelValue: _ctx.direccion,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.direccion) = $event))
                          }, {
                            append: _withCtx(() => [
                              _hoisted_48
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("div", _hoisted_50, [
                              _createVNode(_component_ErrorMessage, { name: "direccion" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.$t("formularios.familiaDetalle.localidad.label")), 1),
                        _createElementVNode("div", _hoisted_53, [
                          _createVNode(_component_el_input, {
                            type: "text",
                            name: "localidad",
                            placeholder: " ",
                            modelValue: _ctx.localidad,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.localidad) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("div", _hoisted_55, [
                              _createVNode(_component_ErrorMessage, { name: "localidad" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.$t("formularios.familiaDetalle.comarca.label")), 1),
                        _createElementVNode("div", _hoisted_58, [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.comarca,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.comarca) = $event)),
                            class: "w-100",
                            disabled: !_ctx.isAdmin
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comarcas, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.text,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"]),
                          _createElementVNode("div", _hoisted_59, [
                            _createElementVNode("div", _hoisted_60, [
                              _createVNode(_component_ErrorMessage, { name: "comarca" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.$t("formularios.familiaDetalle.provincia.label")), 1),
                        _createElementVNode("div", _hoisted_63, [
                          _createVNode(_component_el_select, {
                            name: "provincia",
                            placeholder: " ",
                            modelValue: _ctx.provincia,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.provincia) = $event)),
                            class: "w-100"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "Huesca",
                                value: "Huesca"
                              }),
                              _createVNode(_component_el_option, {
                                label: "Teruel",
                                value: "Teruel"
                              }),
                              _createVNode(_component_el_option, {
                                label: "Zaragoza",
                                value: "Zaragoza"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_64, [
                            _createElementVNode("div", _hoisted_65, [
                              _createVNode(_component_ErrorMessage, { name: "provincia" })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('formularios.familiaDetalle.situacionFamiliarGroup')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("h3", _hoisted_69, _toDisplayString(_ctx.$t("formularios.familiaDetalle.situacionFamiliarGroup")), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("div", _hoisted_72, [
                        _createElementVNode("label", _hoisted_73, _toDisplayString(_ctx.$t("formularios.familiaDetalle.tipologiaFamilia.label")), 1),
                        _createElementVNode("div", _hoisted_74, [
                          _createVNode(_component_el_select, {
                            name: "tipologiaFamilia",
                            class: "w-100",
                            modelValue: _ctx.tipologiaFamilia,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.tipologiaFamilia) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tipologiasFamiliaTodas, (tipologiaFamilia, i) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: i,
                                  label: tipologiaFamilia.nombre,
                                  value: tipologiaFamilia.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_75, [
                            _createElementVNode("div", _hoisted_76, [
                              _createVNode(_component_ErrorMessage, { name: "tipologiaFamilia" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("label", _hoisted_78, _toDisplayString(_ctx.$t("formularios.familiaDetalle.numeroMenores.label")), 1),
                        _createElementVNode("div", _hoisted_79, [
                          _createVNode(_component_el_select, {
                            name: "tipologiaFamilia",
                            class: "w-100",
                            modelValue: _ctx.numeroMenores,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.numeroMenores) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numeroMenoresOpcionesTodas, (numeroMenores, i) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: i,
                                  label: numeroMenores.nombre,
                                  value: numeroMenores.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_80, [
                            _createElementVNode("div", _hoisted_81, [
                              _createVNode(_component_ErrorMessage, { name: "numeroMenores" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("label", _hoisted_83, _toDisplayString(_ctx.$t("formularios.familiaDetalle.conIngresos.label")), 1),
                        _createElementVNode("div", _hoisted_84, [
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.conIngresos,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.conIngresos) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_85, [
                            _createElementVNode("div", _hoisted_86, [
                              _createVNode(_component_ErrorMessage, { name: "conIngresos" })
                            ])
                          ])
                        ])
                      ]),
                      (_ctx.conIngresos)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                            _createElementVNode("label", _hoisted_88, _toDisplayString(_ctx.$t("formularios.familiaDetalle.ingresos.label")), 1),
                            _createElementVNode("div", _hoisted_89, [
                              _createVNode(_component_CurrencyInput, {
                                modelValue: _ctx.ingresos,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.ingresos) = $event)),
                                modelModifiers: { lazy: true },
                                options: {
                      currency: 'EUR',
                      locale: 'es-ES',
                      currencyDisplay: 'symbol',
                      precision: 2,
                      hideCurrencySymbolOnFocus: true,
                      hideGroupingSeparatorOnFocus: true,
                      hideNegligibleDecimalDigitsOnFocus: true,
                      autoDecimalDigits: false,
                      useGrouping: true,
                      accountingSign: false,
                    },
                                type: "text",
                                name: "ingresos",
                                class: "form-control form-control-lg",
                                placeholder: "ej. 11000.21"
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("div", _hoisted_90, [
                                _createElementVNode("div", _hoisted_91, [
                                  _createVNode(_component_ErrorMessage, { name: "ingresos" })
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_92, [
                        _createElementVNode("label", _hoisted_93, _toDisplayString(_ctx.$t("formularios.familiaDetalle.familiaPrioritaria.label")), 1),
                        _createElementVNode("div", _hoisted_94, [
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.familiaPrioritaria,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.familiaPrioritaria) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_95, [
                            _createElementVNode("div", _hoisted_96, [
                              _createVNode(_component_ErrorMessage, { name: "familiaPrioritaria" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_97, [
                        _createElementVNode("label", _hoisted_98, _toDisplayString(_ctx.$t("formularios.familiaDetalle.documentosTodos.label")), 1),
                        _createElementVNode("div", _hoisted_99, [
                          _createElementVNode("ul", _hoisted_100, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentos, (file, i) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: i,
                                class: "el-upload-list__item is-success",
                                tabindex: "0"
                              }, [
                                _createElementVNode("div", _hoisted_101, [
                                  _createElementVNode("a", {
                                    class: "el-upload-list__item-name",
                                    download: `${_ctx.nombre}${_ctx.apellidos}${file.tipo}-${file.nombre}`,
                                    href: file.blob
                                  }, [
                                    _createVNode(_component_el_image, {
                                      class: "align-middle",
                                      style: {"width":"100px","height":"100px"},
                                      src: file.blob
                                    }, {
                                      error: _withCtx(() => [
                                        _hoisted_103
                                      ]),
                                      _: 2
                                    }, 1032, ["src"])
                                  ], 8, _hoisted_102),
                                  _createElementVNode("div", _hoisted_104, [
                                    (_ctx.editingIndex !== i)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_105, [
                                          _createTextVNode(_toDisplayString(file.nombre) + " ", 1),
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-link p-0 ms-2",
                                            onClick: ($event: any) => (_ctx.startEditNombre(i)),
                                            title: "Editar nombre"
                                          }, _hoisted_108, 8, _hoisted_106)
                                        ]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_109, [
                                          _createVNode(_component_el_input, {
                                            modelValue: _ctx.editingNombre,
                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.editingNombre) = $event)),
                                            size: "small",
                                            class: "d-inline-block",
                                            onBlur: ($event: any) => (_ctx.commitEditNombre(i, file.id)),
                                            onKeyup: _withKeys(($event: any) => (_ctx.commitEditNombre(i, file.id)), ["enter"])
                                          }, null, 8, ["modelValue", "onBlur", "onKeyup"])
                                        ]))
                                  ])
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "col-1 d-inline-block btn btn-color-primary btn-active-light-primary text-uppercase mb-5",
                                  onClick: ($event: any) => (_ctx.removeDocumento(i))
                                }, _hoisted_112, 8, _hoisted_110)
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_113, [
                        _createElementVNode("label", _hoisted_114, _toDisplayString(_ctx.$t("formularios.familiaDetalle.nuevosDocumentos.label")), 1),
                        _createElementVNode("div", _hoisted_115, [
                          _createElementVNode("div", _hoisted_116, [
                            _createElementVNode("div", _hoisted_117, [
                              _hoisted_118,
                              _createElementVNode("div", _hoisted_119, [
                                _createElementVNode("h3", _hoisted_120, _toDisplayString(_ctx.$t(
                              "formularios.familiaDetalle.nuevosDocumentos.accion"
                            )), 1),
                                _createElementVNode("span", _hoisted_121, _toDisplayString(_ctx.$t(
                            "formularios.familiaDetalle.nuevosDocumentos.descripcion"
                          )), 1)
                              ])
                            ])
                          ]),
                          _createVNode(_component_ErrorMessage, {
                            name: "certificadoAntecedentes",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('formularios.familiaDetalle.menoresFamilia')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_122, [
                  _createElementVNode("div", _hoisted_123, [
                    _createElementVNode("div", _hoisted_124, [
                      _createElementVNode("h3", _hoisted_125, _toDisplayString(_ctx.$t("formularios.familiaDetalle.menoresGroup")), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_126, [
                    _createElementVNode("div", _hoisted_127, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menoresFamilia, (menor, i) => {
                        return (_openBlock(), _createElementBlock("div", { key: i }, [
                          (i !== 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_128))
                            : _createCommentVNode("", true),
                          _createVNode(_component_Menor, { menor: menor }, null, 8, ["menor"])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('formularios.familiaDetalle.servicios'),
              lazy: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ServiciosTabla, { servicios: _ctx.menoresServicios }, null, 8, ["servicios"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('formularios.familiaDetalle.serviciosColectivos'),
              lazy: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ServiciosColectivosTabla, { servicios: _ctx.menoresServiciosColectivos }, null, 8, ["servicios"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('formularios.familiaDetalle.historico.tab'),
              lazy: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Historico)
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_CrearMenorModal),
    _createVNode(_component_MenorServicioProgramadoModal),
    _createVNode(_component_MenorServicioIndividualModal),
    _createVNode(_component_SendEmailModal, {
      context: _ctx.sendEmailContext,
      onSendEmail: _ctx.onSendEmail
    }, null, 8, ["context", "onSendEmail"])
  ], 64))
}